import React from 'react';
import { Box, Typography, Button, Container, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

const DEFAULT_CONTACT_URL = 'https://www.vertilocity.com';

export default function RegistrationInvitesOnly() {
  const contactUrl = process.env.REACT_APP_CONTACT_URL || DEFAULT_CONTACT_URL;

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: '#0d47a1' }}>
          Registration by invitation
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Self-service signup is not available. Contact Vertilocity to learn more about SecurePoint IQ.
        </Typography>
        <Button
          component="a"
          href={contactUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          color="primary"
          size="large"
          sx={{ textTransform: 'none', mb: 2 }}
        >
          Contact Vertilocity
        </Button>
        <Box>
          <MuiLink component={Link} to="/login" underline="hover">
            Back to login
          </MuiLink>
        </Box>
      </Box>
    </Container>
  );
}
